<template>
<div class="main">
    <TopCtrl/>
    <div class="header">
        <div class="order-status">
            
            <template v-if="orderInfo.completed">
                <Icon :img="require('../../assets/icon-order-done.png')" class="order-status-icon"/> 已完成    
            </template>
            <template v-else>
                <Icon :img="require('../../assets/icon-order-going.png')" class="order-status-icon"/> 未完成 
            </template>
        </div>
        <div class="address">
          <div class="reciever">{{address.receiver}}</div>
          <div class="contact">{{address.telephone}}</div>
          <div class="detail">{{address.area + address.detail}}</div>
        </div>
    </div>

    <div class="item-list-wrap">
        <div class="title">
            商品明细
        </div>
        <div class="list-item" v-for="product in productList" :key="product.productId" @click="gotoProductDetail(product)">
            <Icon class="image" :img="product.image | asProductImage" />
            <div class="info-box">
                <div class="title">{{product.name}}</div>
                <div class="sku">{{product.skuName}} x {{product.amount}}</div>
                <div class="price">{{product.price}} {{prointUnit}}</div>
            </div>
        </div>
        <div class="order-info-list">
            <div class="order-info-item">
                <div class="label">订单编号：</div>
                <div class="value">{{orderInfo.orderno}}</div>
            </div>
            <div class="order-info-item">
                <div class="label">下单时间：</div>
                <div class="value">{{orderInfo.time}}</div>
            </div>
            <div class="order-info-item">
                <div class="label">配送方式：</div>
                <div class="value" v-if="orderInfo.skuType === 1">虚拟商品请到卡包领取</div>
                <div class="value" v-else>{{orderInfo.logistics}}</div>
            </div>
        </div>
        <div class="order-sum">
            <template v-for="fee in orderFees">
                <div :key="fee.id" class="fee-item">
                    <div class="value normal">{{fee.pricePoint}} {{prointUnit}}</div>
                    <div class="label">{{fee.name}}</div>
                </div>
            </template>
            <div class="fee-item">
                <div class="value">{{orderInfo.pricePoint}} {{prointUnit}}</div>
                <div class="label">应付总额</div>
            </div>
        </div>
        <BottomAction text="查看物流信息" :link="'/pages/orders/Logistics?orderno='+orderInfo.orderno"/>
    </div>
</div>
</template>

<script>
import api from "../../api";


export default {
    title: '订单详情',
    bodyClass: 'gray-bg',
    components: {
    },
    data() {
        return {
            prointUnit: api.store.loginedUser.config.pointName,
            orderInfo: {
                orderno: '',
                time: '',
                logistics: '',
                logisticsOrderno: '',
                priceCent: 0,
                pricePoint: 0,
                deliveryType: 1,
                completed: false,
                skuType:''
            },
            address: {
                receiver: '',
                telephone: '',
                area: '',
                detail: ''
            },
            productList: [
                // {
                //     productId: 0,
                //     image: 'https://wx1.sinaimg.cn/mw690/006z3h1rly1ftrll0ql7fj30v40uc43h.jpg',
                //     name: '南极人',
                //     skuName: '小背心',
                //     price: 1000,
                //     amount: 1
                // }
            ],
            orderFees: [
                // {extInfo: "", id: 10105, orderId: 10054, priceCent: 2500, pricePoint: 2500, type: 101}
            ]

        }
    },
    methods: {
        gotoProductDetail(product){
            this.$routerPush(this, '/pages/products/Detail?skuId='+product.productId);
        }
    },
    computed: {
        
    },
    mounted () {
        this.$showLoading('加载中...');
        var orderno = this.$route.query.orderno;
        api.order.getOrderDetail(orderno, res=>{
            console.log(res);
            //地址
            this.address.receiver = res.order.receiverName;
            this.address.telephone = res.order.receiverPhone;
            this.address.detail = res.order.receiverAddress;
            

            //订单信息
            this.orderInfo.orderno = res.order.orderno;
            this.orderInfo.time = res.order.payTime;
            this.orderInfo.pricePoint = res.order.finalPricePoint;
            this.orderInfo.priceCent = res.order.finalPriceCent;
            this.orderInfo.logistics = res.order.supplierName;
            this.orderInfo.logisticsOrderno = res.order.supplierOrderno;
            this.orderInfo.deliveryType = res.order.deliveryType;
            this.orderInfo.completed = res.order.completed;
            this.orderInfo.skuType = res.order.skuType;

            //明细
            res.orderItems.forEach(oi => {
                this.productList.push({
                    productId: oi.skuId,
                    image: oi.image,
                    name: oi.title,
                    skuName: oi.specName,
                    price: oi.totalPricePoint,
                    amount: oi.count
                });
            });

            this.orderFees = res.orderFees;

            this.$hideLoading();

        });

    }
}
</script>
<style scoped lang="less">
    .header{ 
        background-image: linear-gradient(to bottom, #fc7337 , #ff5a52);
        position: relative;
        z-index: 1;
        height: 36vw;
        margin-bottom: 11.33vw;

        .address{
            box-sizing:border-box;
            @addressWidth: 91.73vw;
            @addressHeight: 29.6vw;
            position: absolute;
            bottom: -8.8vw;
            z-index: 2;
            background: white;
            width: @addressWidth;
            height: @addressHeight;
            left: 50%;
            margin-left: -@addressWidth / 2;
            border-radius: 2.4vw;
            padding: 6.1vw;
            font-size: 4vw;

            .reciever,
            .contact {
            display: inline-block;
            line-height: 1em;
            margin-bottom: 2.66vw;
            margin-right: 4.8vw;
            color: #333;
            }
            .detail {
            color: #666666;
            font-size: 3.733vw;
            }
        }
    }

    .item-list-wrap{
        margin-bottom: .93vw;

        .title{
            padding: 4vw;
            color: #333333;
            font-size: 3.733vw;
            margin-bottom: 1px;
            background: #fff;
            line-height: 1.5em;
            max-height: 3em;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }

        .list-item{
            margin: 0;
            padding: 0;
            position: relative;
            z-index: 1;
            height: 36vw;
            background: #fff;
            margin-bottom: 1px;

            .image{
                position: absolute;
                z-index: 2;
                left: 4vw;
                top: 4vw;
                width: 26.66vw;
                height: 26.66vw;
            }

            .info-box{
                position: absolute;
                z-index: 2;
                left: 34.6vw;
                top: 4vw;
                width: 59.46vw;

                .title{
                    padding: 0;
                    line-height: 1.5em;
                    font-size: 3.46vw;
                    color: #333;
                }

                .sku{
                    position: absolute;
                    z-index: 2;
                    left: 0;
                    top: 12.8vw;
                    font-size: 3.2vw;
                    color: #999999;
                }

                .price{
                    position: absolute;
                    z-index: 2;
                    left: 0;
                    top: 22vw;
                    font-size: 3.2vw;
                    color: #ff0129;
                }
            }

            
        }
    }

    .order-info-list{
        padding: 4vw;
        margin-bottom: .93vw;
        background: #fff;
        
        .order-info-item{
            font-size: 3.2vw;
            line-height: 1.5em;

            .label{
                color: #666666;
                width: 6em;
                display: inline-block;
            }

            .value{
                color: #999;
                display: inline-block;
            }
        }
    }
    .order-sum{
        font-size: 4vw;
        line-height: 12vw;
        background: #fff;
        padding: 0 3.73vw;
        color: #333333;
        margin-bottom: .93vw;


        .fee-item{
            clear: both;
        }

        .value{
            float: right;
            color: #ff0129;

            &.normal{
                color: #333;
            }
        }
    }

    .order-status{
        position: absolute;
        top: 7.2vw;
        left: 6.1vw;
        font-size: 3.7vw;
        color: #fff;

        .order-status-icon{
            @size: 1em;
            width: @size;
            height: @size;
            margin-right: .2em;
        }
    }
    

</style>




// WEBPACK FOOTER //
// src/pages/orders/Detail.vue